import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import CONSTANT from '../../define/constant';
import { DIALOG_TYPE, DOCUMENT_TYPE } from '../../define/global';
import IcoHwp40 from '../../img/ico_hwp_40.png';
import IcoHwp402x from '../../img/ico_hwp_40@2x.png';
import IcoSheet40 from '../../img/ico_sheet_40.png';
import IcoSheet402x from '../../img/ico_sheet_40@2x.png';
import IcoSlide40 from '../../img/ico_slide_40.png';
import IcoSlide402x from '../../img/ico_slide_40@2x.png';
import IcoWord40 from '../../img/ico_word_40.png';
import IcoWord402x from '../../img/ico_word_40@2x.png';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { useArrangeButtonOrder, useLinkEditorUrl } from '../../utils/util';
import { useResponsiveCss } from '../dialog/OpenDocumentDialog';
import { noTextSelect } from './CssCommon';

const SIDE_BUTTON_WIDTH_DISTANCE = CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_WIDTH / 2;
const SIDE_BUTTON_WIDTH_DISTANCE_RESPONSIVE =
  CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_WIDTH_RESPONSIVE / 2;
const SIDE_BUTTON_HEIGHT_DISTANCE =
  Math.round((CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_HEIGHT + CONSTANT.DIALOG_HEADER_HEIGHT) / 2) -
  CONSTANT.DIALOG_HEADER_HEIGHT;

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(${SIDE_BUTTON_WIDTH_DISTANCE}px, -${SIDE_BUTTON_HEIGHT_DISTANCE}px);
  display: flex;
  flex-direction: column;
  ${({ cssExt }) => cssExt && cssExt}
`;

const HwpBackgroundColor = css`
  background-color: #e4f6ff;
  color: #002d64;
  &:hover {
    background-color: #cfe9fe;
  }
  &:active {
    background-color: #bcdefd;
  }
`;

const SheetBackgroundColor = css`
  background-color: #eafdcd;
  color: #133500;
  &:hover {
    background-color: #dbf6bb;
  }
  &:active {
    background-color: #cdefaa;
  }
`;

const SlideBackgroundColor = css`
  background-color: #fff2e0;
  color: #26231f;
  &:hover {
    background-color: #ffe7c9;
  }
  &:active {
    background-color: #ffddb4;
  }
`;

const ButtonItem = styled.div`
  width: ${CONSTANT.OPEN_DOCUMENT_DIALOG_SIDE_BUTTON_WIDTH}px;
  height: 104px;
  border: solid 1px #b1b6bb;
  border-radius: 0px 6px 6px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1px;
  ${({ cssExt }) => cssExt && cssExt}
  cursor:pointer;
  ${noTextSelect}
`;

const ButtonFormatName = styled.div`
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: inherit;
`;

const ButtonString = styled.div`
  font-size: 11px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: inherit;
`;

export default function SideButtonArea() {
  const { t } = useTranslation();
  const appData = useAppDataSliceSelector();
  const responsiveCss = useResponsiveCss();
  const linkEditorUrl = useLinkEditorUrl();
  const arrangeButtonOrder = useArrangeButtonOrder();

  const menus = arrangeButtonOrder([
    {
      type: DOCUMENT_TYPE.HWP,
      icon: { src: IcoHwp40, srcSet: IcoHwp402x },
      formatName: 'HomeButton.WebHwp',
      cssExt: HwpBackgroundColor
    },
    {
      type: DOCUMENT_TYPE.SHEET,
      icon: { src: IcoSheet40, srcSet: IcoSheet402x },
      formatName: 'HomeButton.WebSheet',
      cssExt: SheetBackgroundColor
    },
    {
      type: DOCUMENT_TYPE.SLIDE,
      icon: { src: IcoSlide40, srcSet: IcoSlide402x },
      formatName: 'HomeButton.WebSlide',
      cssExt: SlideBackgroundColor
    },
    {
      type: DOCUMENT_TYPE.WORD,
      icon: { src: IcoWord40, srcSet: IcoWord402x },
      formatName: 'HomeButton.WebWord',
      cssExt: HwpBackgroundColor
    }
  ]);

  const getComponent = ({ type, icon, formatName, cssExt }) => {
    return (
      <ButtonItem
        key={t(formatName)}
        cssExt={cssExt}
        onClick={() => {
          linkEditorUrl(type, DIALOG_TYPE.DIALOG_OPEN_DOCUMENT);
        }}>
        <img width="40px" height="40px" src={icon.src} srcSet={icon.srcSet} alt={t(formatName)} />
        <ButtonFormatName>{t(formatName)}</ButtonFormatName>
        <ButtonString>{t('HomeButton.LinkDirect')}</ButtonString>
      </ButtonItem>
    );
  };

  return (
    <Wrapper
      cssExt={responsiveCss(css`
        transform: translate(
          ${SIDE_BUTTON_WIDTH_DISTANCE_RESPONSIVE}px,
          -${SIDE_BUTTON_HEIGHT_DISTANCE}px
        );
      `)}>
      {menus.map((menu) => getComponent(menu))}
    </Wrapper>
  );
}
